import { Github, Linkedin, Mail } from 'lucide-react'

export default function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-white border-t border-gray-200 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-2">
          
          {/* Brand & Copyright */}
          <div className="text-center sm:text-left">
            <p className="text-gray-500 text-xs">
              © {currentYear} <span className="font-semibold text-blue-600">RBApps</span>. All rights reserved.
            </p>
          </div>

          {/* Social Links */}
          <div className="flex items-center gap-2">
            <a 
              href="https://github.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-50 to-blue-50 border border-blue-200 hover:border-blue-400 hover:from-blue-100 hover:to-blue-100 flex items-center justify-center transition-all duration-200 hover:scale-105 text-blue-600 hover:text-blue-700 shadow-sm hover:shadow-md"
              aria-label="GitHub"
            >
              <Github size={14} />
            </a>
            <a 
              href="https://linkedin.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-50 to-blue-50 border border-blue-200 hover:border-blue-400 hover:from-blue-100 hover:to-blue-100 flex items-center justify-center transition-all duration-200 hover:scale-105 text-blue-600 hover:text-blue-700 shadow-sm hover:shadow-md"
              aria-label="LinkedIn"
            >
              <Linkedin size={14} />
            </a>
            <a 
              href="mailto:support@rbapps.com"
              className="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-50 to-blue-50 border border-blue-200 hover:border-blue-400 hover:from-blue-100 hover:to-blue-100 flex items-center justify-center transition-all duration-200 hover:scale-105 text-blue-600 hover:text-blue-700 shadow-sm hover:shadow-md"
              aria-label="Email"
            >
              <Mail size={14} />
            </a>
          </div>

        </div>
      </div>
    </footer>
  )
}
